export default __webpack_public_path__ + "static/media/Contact.7deef043.svg";